import React from 'react';

import Button from './Button';

export default function Filters({
  filters,
  handleClick,
  selectedElement,
  isSliding = false,
  version = 'filter',
  additionalClassNames = '',
  isVertical = false
}) {
  return (
    <>
      {filters && (
        <div className={`filters ${isVertical ? '--vertical' : ''}`}>
          {filters.map((filter, index) => {
            return (
              <div key={filter.id}>
                <Button
                  button={{
                    label:
                      filter.blockContent?.label ||
                      filter.blockContent?.headingOne ||
                      filter.blockContent?.headingTwo ||
                      filter.title,
                    version: version,
                    additionalClassNames: `${additionalClassNames} ${
                      selectedElement === filter ? '--active' : ''
                    }`
                  }}
                  onClick={() => handleClick(isSliding ? index : filter)}
                  isDisabled={selectedElement === filter}
                  isActive={
                    selectedElement === filter ||
                    selectedElement?.id === filter?.id
                  }
                />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
